export const STORAGE_KEY = 'gotrue.user';

export const PLAN_0 = 'free';

export const PLAN_1 = 'individual';

export const PLAN_2 = 'department';

export const PLAN_3 = 'organization';

export const SUBSCRIPTION_PLANS = {
  PLAN_0,
  PLAN_1,
  PLAN_2,
  PLAN_3,
};

export const SUBSCRIPTION_PLANS_PAID = [
  PLAN_1,
  PLAN_2,
  PLAN_3,
];